/**
 * Gestion réactive de l'état pour les catégories.
 *
 * Ce module définit et exporte plusieurs variables réactives liées :
 * - pageCategory : numéro de page actuel pour la pagination.
 * - form_CategorieBody : données du formulaire de création/modification d’une catégorie.
 * - isCategoryActivated : statut d’activation d’une catégorie.
 * - idCategory : identifiant de la catégorie sélectionnée.
 * - isDeletedFromCategory : indique si une catégorie a été supprimée.
 * - searchQueryCategory : terme de recherche appliqué aux catégories.
 *
 * Utilise les API réactives de Vue 3 (ref et reactive).
 */
import { reactive, ref } from 'vue';
import type { ICategoryBody } from '@/types/category.types';

export const pageCategory = ref(1);
export const form_CategorieBody = reactive<ICategoryBody>({
  designation: '',
  description: '',
});
export const isCategoryActivated = ref(false);
export const idCategory = ref(null);
export const isDeletedFromCategory = ref(false);
export const searchQueryCategory = ref('');
export const descriptionCourte = reactive({ fr: '', nl: '', en: '' });
export const typeCategorie = ref('food');
export const defaultProductLang = ref<'fr' | 'nl' | 'en'>('fr');
export const form_CatDesignation = reactive({ fr: '', nl: '', en: '' });
export const formStepOne = reactive({
  category: '',
  categoryId: '',
  nomClientFr: '',
  nomClientNl: '',
  nomClientEn: '',
  nomInterne: '',
  sameAsClient: false,
});
